<template>
  <v-container :class="{ 'pa-0': $vuetify.breakpoint.xs }">
    <qrScannerForm :qrReader="qrReader" />
    <v-layout :class="[$vuetify.breakpoint.xsOnly ? ' pt-0' : 'pa-0']">
      <AddWorkRequestForms onlyMy />
    </v-layout>
    <v-data-iterator
      :items="priorityController ? workRequestsPriority : filteredWorkRequests"
      :search="search"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      disable-initial-sort
      content-tag="v-layout"
      wrap
    >
      <v-layout slot="header" column>
        <v-toolbar
          class="mb-2"
          color="cyan"
          dark
          flat
          :extended="!$vuetify.breakpoint.mdAndUp"
        >
          <v-tooltip bottom>
            <template slot="activator">
              <button @click="showfilter = !showfilter" class="mr-2">
                <v-icon>filter_list</v-icon>
              </button>
            </template>
            <span>{{
              showfilter
                ? $t("equipment.workRequests.hideFilter")
                : $t("equipment.workRequests.showFilter")
            }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template slot="activator">
              <button
                @click="
                  showArchive = !showArchive;
                  refresh();
                "
              >
                <v-icon size="20px">{{
                  showArchive ? "fas fa-folder-open" : "fas fa-folder"
                }}</v-icon>
              </button>
            </template>
            <span>{{
              showArchive
                ? $t("equipment.workRequests.hideArchive")
                : $t("equipment.workRequests.showArchive")
            }}</span>
          </v-tooltip>

          <!-- <v-toolbar-title>{{ $t('equipment.workRequests.title') }}</v-toolbar-title> -->
          <v-toolbar-title class="ml-2">
            <v-flex
              :class="$vuetify.breakpoint.mdAndUp ? 'd-flex' : 'gridView'"
            >
              <span class="pr-2 mb-0">{{
                $t("equipment.workRequests.title")
              }}</span>
              <div
                class="d-flex"
                :class="{ 'pt-2': $vuetify.breakpoint.mdAndUp }"
              >
                <v-flex class="align-center">
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu1"
                    lazy
                    max-width="290"
                    full-width
                    hide-details
                    transition="scale-transition"
                  >
                    <v-text-field
                      id="dateEnd"
                      class="pa-0"
                      slot="activator"
                      :value="dateStart | formatDate"
                      readonly
                      hide-details
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateStart"
                      :locale="$vuetify.t('$vuetify.datelocale')"
                      :max="dateEnd"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-icon size="13">minimize</v-icon>
                <v-flex>
                  <v-menu
                    :close-on-content-click="false"
                    v-model="menu2"
                    full-width
                    max-width="290"
                    lazy
                    transition="scale-transition"
                  >
                    <v-text-field
                      slot="activator"
                      id="dateStart"
                      class="pa-0"
                      :value="dateEnd | formatDate"
                      readonly
                      hide-details
                      single-line
                    ></v-text-field>
                    <v-date-picker
                      v-model="dateEnd"
                      :locale="$vuetify.t('$vuetify.datelocale')"
                      :min="dateStart"
                      :max="today"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </div>
            </v-flex>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <template v-slot:extension>
            <v-tabs v-model="filterMode" color="cyan" slider-color="yellow">
              <v-tab v-for="(tabItem, i) in tabItems" :key="i">{{
                tabItem.name
              }}</v-tab>
              <v-checkbox
                class="mt-2 ml-5"
                color="white"
                v-model="priorityController"
                label="По приоритету"
              ></v-checkbox>
            </v-tabs>
          </template>
          <EamSearch />
          <v-btn
            @click="
              qrReader = !qrReader;
              topFunction();
            "
            icon
          >
            <v-icon class="pr-4 pl-4">fa-qrcode</v-icon>
          </v-btn>
        </v-toolbar>

        <v-layout row slot="extension" wrap v-if="showfilter">
          <v-flex v-for="header in headers" :key="header.text" xs12 md4 sm6>
            <div v-if="filters.hasOwnProperty(header.value)">
              <v-combobox
                :label="header.text"
                flat
                multiple
                clearable
                :items="columnValueList(header.value)"
                v-model="filters[header.value]"
                color="blue"
                small-chips
                deletable-chips
                dense
                :prepend-icon="header.icon"
              ></v-combobox>
            </div>
          </v-flex>
        </v-layout>
      </v-layout>

      <v-flex slot="item" slot-scope="props" pa-2 xs12 sm6>
        <WorkRequestCard :workRequest="props.item" />
      </v-flex>
    </v-data-iterator>
  </v-container>
</template>

<script>
import WorkRequestCard from '../components/WorkRequestCard'
import AddWorkRequestForms from '../components/simple-forms/AddWorkRequestForms'
import EamSearch from '../components/EamSearch'
import qrScannerForm from './qrScannerForm'
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'AllWorkRequests',
  components: {
    WorkRequestCard,
    AddWorkRequestForms,
    EamSearch,
    qrScannerForm,
  },
  props: {
    onlyMy: Boolean
  },
  mounted() {
    this.refresh()
  },
  filters: {
    formatDate: value => {
      if (value) {
        return moment(value).format('DD.MM.YYYY').toString()
      }
    }
  },
  data: vm => {
    return {
      dateStart: vm.$store.state.auth.user.dateStart,
      dateEnd: new Date().toISOString().substr(0, 10).toLocaleString(),
      qrReader: false,
      menu1: false,
      menu2: false,
      today: new Date().toISOString().substr(0, 10).toLocaleString(),
      rowsPerPageItems: [12, 36, 108],
      pagination: {
        rowsPerPage: 12
      },
      // filters: {
      //   DeclarerName: [],
      //   ResponsibleName: [],
      //   Status: [],
      //   CategoryName: [],
      //   DirectionName: [],
      //   EquipmentName: [],
      //   StageName: []
      // },
      // showfilter: false,
      showArchive: false,
      filterModeVal: null
    }
  },
  methods: {
    ...mapActions(['updateWorkRequests']),
    workRequestPeriod() {
      this.updateWorkRequests({ filterMode: this.filterModeReq, showArchive: this.showArchive, dateFrom: moment(this.dateStart), dateTo: moment(this.dateEnd).add(1, 'days') })
    },
    columnValueList(val) {
      return this.workRequests.map(e => e[val]).sort()
    },
    topFunction() {
      if (this.qrReader) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      }
    },
    refresh() {
      this.updateWorkRequests({ filterMode: this.filterModeReq, showArchive: this.showArchive, dateFrom: moment(this.dateStart), dateTo: moment(this.dateEnd).add(1, 'days'), selectByСreationDate: !this.planOrDate })
    }
  },
  computed: {
    SelectionWorkRequestDays() {
      return this.$store.state.auth.user && this.$store.state.auth.user.SelectionWorkRequestDays ? this.$store.state.auth.user.SelectionWorkRequestDays : 30
    },
    priorityController: {
      get: function () {
        return this.$store.state.base.priorityController
      },
      set: function (newValue) {
        this.$store.commit('setPriorityController', newValue)
      }
    },
    workRequestsPriority() {
      let massive = this.filteredWorkRequests.slice(0)
      return massive.sort(function (a, b) {
        let apriority = a.Priority == 0 ? 13 : a.Priority
        let bpriority = b.Priority == 0 ? 13 : b.Priority
        return apriority - bpriority
      })
    },
    showfilter: {
      get: function () {
        return this.$store.state.base.showfilter
      },
      set: function (newValue) {
        this.$store.state.base.showfilter = newValue
      }
    },
    filters: {
      get: function () {
        return this.$store.state.base.filters
      },
      set: function (newValue) {
        this.$store.state.base.filters = newValue
      }
    },
    tabItems() {
      return [
        { name: this.$i18n.t("navigation.all"), value: "my" },
        { name: this.$i18n.t("navigation.my"), value: "my" },
        { name: this.$i18n.t("navigation.direction"), value: "direction" },
        { name: this.$i18n.t("navigation.favorite"), value: "fav" },
        { name: this.$i18n.t("navigation.myStage"), value: "myStage" }
      ];
    },
    headers() {
      return [
        {
          text: this.$t('equipment.workRequests.declarerName'),
          value: 'DeclarerName',
          icon: 'person'
        },
        {
          text: this.$t('equipment.workRequests.responsibleName'),
          value: 'ResponsibleName',
          icon: 'directions_run'
        },
        {
          text: this.$t('equipment.workRequests.stage'),
          value: 'StageName',
          icon: 'control_camera'
        },
        {
          text: this.$t('equipment.workRequests.categoryName'),
          value: 'CategoryName',
          icon: 'category'
        },
        {
          text: this.$t('equipment.workRequests.directionName'),
          value: 'DirectionName',
          icon: 'directions'
        },
        {
          text: this.$t('equipment.workRequests.equipmentName'),
          value: 'EquipmentName',
          icon: 'home'
        }
      ]
    },
    loading() {
      return this.$store.state.base.loading
    },
    workRequests() {
      return this.$store.state.workRequests.workRequests
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    filteredWorkRequests() {
      return this.workRequests.filter(e => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(e[f])
        })
      })
    },
    currentLocale() {
      return this.$store.getters.currentLocale
    },
    search: {
      get: function () {
        return this.$store.state.base.search
      },
      set: function (newValue) {
        this.$store.state.base.search = newValue
      }
    },
    filterMode: {
      get: function () {
        if (this.filterModeVal === null) {
          const parsedFilterMode = parseInt(
            localStorage.getItem('eamWorkRequestsMode')
          )
          this.filterModeVal = parsedFilterMode || 0
        }
        return this.filterModeVal
      },
      set: function (newValue) {
        this.filterModeVal = newValue
        localStorage.setItem('eamWorkRequestsMode', newValue.toString())
        this.refresh()
      }
    },
    filterModeReq() {
      return this.filterMode == 0
        ? 'all'
        : this.filterMode == 1
          ? 'my'
          : this.filterMode == 2
            ? 'direction'
            : this.filterMode == 3
              ? 'fav'
              : this.filterMode == 4
                ? 'myStage'
                : ''
    }
  },
  watch: {
    isAuthenticated() {
      this.refresh()
    },
    currentLocale() {
      this.refresh()
    },
    dateStart() {
      this.workRequestPeriod()
    },
    dateEnd() {
      this.workRequestPeriod()
    }
  }
}
</script>

<style>
#dateEnd,
#dateStart {
  padding: 0px 0px;
  font-size: 13px;
  width: 67px;
}
.gridView {
  display: grid;
}
</style>